export var Permission;
(function (Permission) {
    Permission["CROSS_CLIENTS"] = "cross_clients";
    Permission["CREATE_USER"] = "create_user";
    Permission["READ_USER"] = "read_user";
    Permission["LIST_USERS"] = "list_users";
    Permission["UPDATE_USER"] = "update_user";
    Permission["DELETE_USER"] = "delete_user";
    Permission["CREATE_CLIENT"] = "create_client";
    Permission["READ_CLIENT"] = "read_client";
    Permission["LIST_CLIENTS"] = "list_clients";
    Permission["UPDATE_CLIENT"] = "update_client";
    Permission["DELETE_CLIENT"] = "delete_client";
    Permission["CREATE_ROLE"] = "create_role";
    Permission["READ_ROLE"] = "read_role";
    Permission["LIST_ROLES"] = "list_roles";
    Permission["UPDATE_ROLE"] = "update_role";
    Permission["DELETE_ROLE"] = "delete_role";
    Permission["CREATE_PERMISSION"] = "create_permission";
    Permission["READ_PERMISSION"] = "read_permission";
    Permission["LIST_PERMISSIONS"] = "list_permissions";
    Permission["UPDATE_PERMISSION"] = "update_permission";
    Permission["DELETE_PERMISSION"] = "delete_permission";
    Permission["CREATE_PREFERENCE"] = "create_preference";
    Permission["READ_PREFERENCE"] = "read_preference";
    Permission["LIST_PREFERENCES"] = "list_preferences";
    Permission["UPDATE_PREFERENCE"] = "update_preference";
    Permission["DELETE_PREFERENCE"] = "delete_preference";
    Permission["LIST_COMMENTS"] = "list_comments";
    Permission["CREATE_COMMENT"] = "create_comment";
    Permission["DELETE_COMMENT"] = "delete_comment";
    Permission["UPDATE_COMMENT"] = "update_comment";
    Permission["APPROVE_PROGRAM_REQUEST"] = "approve_program_request";
})(Permission || (Permission = {}));
/**
 * Standard admin permissions
 */
export const ADMIN_PERMISSIONS = [
    Permission.CROSS_CLIENTS,
    Permission.CREATE_USER,
    Permission.UPDATE_USER,
    Permission.DELETE_USER,
    Permission.CREATE_CLIENT,
    Permission.LIST_CLIENTS,
    Permission.UPDATE_CLIENT,
    Permission.DELETE_CLIENT,
    Permission.CREATE_ROLE,
    Permission.LIST_ROLES,
    Permission.UPDATE_ROLE,
    Permission.DELETE_ROLE,
    Permission.CREATE_PERMISSION,
    Permission.LIST_PERMISSIONS,
    Permission.UPDATE_PERMISSION,
    Permission.DELETE_PERMISSION,
];
/**
 * Standard user permissions
 */
export const USER_PERMISSIONS = [
    Permission.READ_USER,
    Permission.READ_CLIENT,
    Permission.READ_PREFERENCE,
    Permission.UPDATE_USER,
];
export const hasPermission = (user, ...permissions) => {
    if (!user)
        return false;
    return (user.isSuperuser ||
        permissions.some(permission => user.permissions?.includes(permission)) ||
        permissions.length === 0);
};
